import { PROFILE_ROUTE } from "_constants";
import { lazy } from "react";

const Profile = lazy(() => import("pages/profile"));

export const profileRoutes = [{ path: PROFILE_ROUTE, element: <Profile /> }];
